import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { get_linked_dataset_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import {
  AUTOMATION_LATEST_VERSION_KEY,
  AUTOMATION_VERSIONS_KEY,
  LINKED_DATASETS_KEY,
} from '@/utils/queryKeys.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';

type props = {
  datasetId: string;
};

const useDeleteLinkedDataset = (
  options: UseMutationOptions<void, AxiosError, props>,
): UseMutationResult<void, AxiosError, props> => {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();
  const automationId = useAutomationId();

  return useMutation<void, AxiosError, props>({
    ...options,
    mutationFn: async ({ datasetId }: props) => {
      await apiClient.delete(get_linked_dataset_url(datasetId));
      await queryClient.invalidateQueries({ queryKey: LINKED_DATASETS_KEY(automationId) });
      await queryClient.invalidateQueries({ queryKey: AUTOMATION_LATEST_VERSION_KEY(automationId) });
      await queryClient.invalidateQueries({ queryKey: AUTOMATION_VERSIONS_KEY(automationId) });
    },
  });
};

export default useDeleteLinkedDataset;
